// Prikaz imena pacijenta u redosledu "Prezime Ime".
//
// Neki endpointi (korisnici, terapije) šalju odvojena polja `firstName` /
// `lastName`, a neki (razgovori, zahtevi, dnevne aktivnosti) šalju samo spojeno
// ime sa beka (`patientName` / `userName`) u redosledu "Ime Prezime". Zato ovde
// prvo koristimo odvojena polja ako postoje, a u suprotnom obrćemo spojeni string.

// "Ime Prezime" -> "Prezime Ime". Pretpostavka: poslednja reč je prezime (najčešći
// slučaj na srpskom). Radi i za višečlana imena: "Ana Marija Jović" -> "Jović Ana Marija".
export const reverseFullName = (fullName) => {
  const parts = String(fullName ?? '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (parts.length < 2) return parts.join(' ');

  const last = parts[parts.length - 1];
  const rest = parts.slice(0, -1);
  return [last, ...rest].join(' ');
};

// "Prezime Ime" iz objekta koji ima ili odvojena polja (firstName/lastName) ili
// samo spojeno ime sa beka (userName / patientName / name). Vraća `fallback` ako
// nema nijednog izvora imena.
export const formatNameLastFirst = (source, fallback = '-') => {
  const first = source?.firstName?.trim?.() || '';
  const last = source?.lastName?.trim?.() || '';

  if (first || last) {
    return [last, first].filter(Boolean).join(' ');
  }

  const joined = source?.userName || source?.patientName || source?.name || '';
  return reverseFullName(joined) || fallback;
};
